import Button from '../base/button';

import {registerMPElement} from '../../util/register-element';

import template from './index.jade';
import css from './index.styl?inline';

export enum THEME_ENUM {
  primary = `primary`,
  secondary = `secondary`,
  tertiary = `tertiary`,
  select = `select`,
}

export enum ButtonSize {
  Medium = `medium`,
  Large = `large`,
}

export enum ButtonType {
  Destructive = `destructive`,
  Info = `info`,
  Success = `success`,
  Warn = `warn`,
}

export default registerMPElement(
  `mp-button`,
  class extends Button {
    static get attrsSchema() {
      return {
        ...super.attrsSchema,
        class: `string`,
        icon: `string`,
        size: {type: `string`, enum: Object.values(ButtonSize), default: ButtonSize.Medium},
        theme: {type: `string`, enum: Object.values(THEME_ENUM), default: THEME_ENUM.secondary},
        type: {type: `string`, enum: Object.values(ButtonType), default: ButtonType.Info},
        pressed: `boolean`,
      };
    }

    get config() {
      return Object.assign(super.config, {
        css,
        template,
        helpers: {
          ...super.config.helpers,
          ButtonType,
        },
      });
    }
  },
);
